module.exports = __webpack_public_path__ + "static/media/S-task09_nodeLink.4204dd3a.png";